<template>
    <div>
        <div class="text-center" v-if="drawChart">
            <GChart
                type="PieChart"
                :data="ocupacionTotal"
                :options="chartOptions"
            />
        </div>
        <h5>*El TOTAL DISPONIBLE refleja el aforo máximo de todas las zonas menos las butacas confirmadas/cerradas</h5>
    </div>
</template>

<script>
    export default {
        props: ['valores_grafico'],
        data() {
            return {
                loading: false,
                chartOptions: {
                    height: 364,
                    chartArea: { width:'auto' },
                    pieHole: 0.4,
                    sliceVisibilityThreshold: 0
                },
                drawChart: false
            }
        },
        computed: {
            ocupacionTotal() {
                return this.valores_grafico || null;
            },
        },
        methods: {
            draw() {
                setTimeout(() => {
                    this.drawChart = !this.drawChart;
                }, 10);
            },
        }
    }
</script>
